/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputBase from '@material-ui/core/InputBase';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import Pagination from './Pagination/Pagination';
import { PAGE_SIZES } from '../../../pages/draftManagement/useDraftManagement';
import useStyles from './FOTableFooterStyle';

function FOTableFooter({ totalCount, pageSize, setPageSize, page, setPage }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const onChangeElementsDisplayed = (event) => {
    setPage(0);
    setPageSize(event.target.value);
  };

  return (
    <div className={classes.container}>
      {totalCount > 0 && (
        <>
          <form className={classes.pageSizeContainer}>
            <Typography>{t('pagination.rows-per-page')}</Typography>
            <Select
              variant="outlined"
              className={classes.pageSizeSelector}
              open={open}
              onOpen={handleOpen}
              onClose={handleClose}
              IconComponent={() =>
                open ? (
                  <ExpandLess className={clsx(classes.expandIcon, 'MuiSelect-icon MuiSelect-iconOutlined')} />
                ) : (
                  <ExpandMore className={clsx(classes.expandIcon, 'MuiSelect-icon MuiSelect-iconOutlined')} />
                )
              }
              value={pageSize}
              onChange={onChangeElementsDisplayed}
              input={<InputBase />}
              MenuProps={{
                getContentAnchorEl: null,
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'center',
                },
                transformOrigin: {
                  vertical: 'bottom',
                  horizontal: 'center',
                },
              }}
            >
              {PAGE_SIZES?.map((range, index) => (
                <MenuItem key={`${range}-${index}`} value={range}>
                  {range}
                </MenuItem>
              ))}
            </Select>

            <Typography className={classes.showingResults}>
              {t('pagination.showing.results', {
                startElement: page * pageSize + 1,
                endElement: Math.min((page + 1) * pageSize, totalCount),
                totalElements: totalCount,
              })}
            </Typography>
          </form>
          <Pagination totalCount={totalCount} page={page} pageSize={pageSize} setPage={setPage} />
        </>
      )}
    </div>
  );
}

function propsAreEqual(prevProps, nextProps) {
  return (
    prevProps.totalCount === nextProps.totalCount &&
    prevProps.pageSize === nextProps.pageSize &&
    prevProps.page === nextProps.page
  );
}

const MemoizedFOTableFooter = React.memo(FOTableFooter, propsAreEqual);

export default MemoizedFOTableFooter;
